import { Box, Typography } from '@mui/material';
import React from 'react';
import logoAlertAiEducation from '../../../../assets/images/favicon.png';

interface PdfViewerProps {
  formData: {
    subTitle: string;
    wallpaper?: File | null;
    logos?: (File | null)[];
  };
  boxRef: React.Ref<unknown>;
}

const PdfViewerFirst: React.FC<PdfViewerProps> = ({ formData, boxRef }) => {
  return (
    <Box
      sx={{
        width: '95vw',
        height: '90vh',
        maxWidth: 'calc(93vh * 0.700)',
        aspectRatio: '1 / 1.414',
        backgroundColor: 'white',
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        margin: 'auto',
        position: 'relative',
      }}
      ref={boxRef}
    >
      <Box
        sx={{
          height: '100%',
          width: '7vh',
          backgroundColor: '#224FA2',
        }}
      />

      <div style={{ width: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            height: '35vh',
            marginBottom: '1rem',
          }}
        >
          <img
            src={
              formData.wallpaper ? URL.createObjectURL(formData.wallpaper) : ''
            }
            alt="Painel ilustrativo"
            style={{
              minWidth: '100%',
              height: 'auto',
            }}
          />
        </Box>
        <Typography
          sx={{
            fontSize: '2.5rem',
            width: '50%',
            fontWeight: 'bold',
            color: '#224FA2',
            marginBottom: '0.5rem',
            lineHeight: 1,
            paddingLeft: '24px',
          }}
        >
          Proposta
          <br />
          comercial
        </Typography>
        <Typography
          sx={{
            fontSize: '1.2rem',
            width: '70%',
            fontWeight: 'bold',
            color: '#224FA2',
            marginBottom: '0.1rem',
            lineHeight: 1,
            paddingLeft: '24px',
          }}
        >
          {formData.subTitle ? formData.subTitle : 'Digite aqui seu sub-título'}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
            width: '100%',
            mt: '2rem',
            height: '6vh',
            paddingLeft: '24px',
          }}
        >
          {(formData.logos ?? [])
            .filter((logo): logo is File => logo instanceof File)
            .map((logo, index) => (
              <img
                key={index}
                src={URL.createObjectURL(logo)}
                alt={`Logo ${index + 1}`}
                style={{
                  height: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                }}
              />
            ))}

          <img
            src={logoAlertAiEducation}
            alt="Logo AlertAi"
            style={{
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </Box>
      </div>
    </Box>
  );
};

export default PdfViewerFirst;
